/**
 * Generated bundle index. Do not edit.
 */

export {IImage,SlideshowModule} from './public_api';

export {SlideshowComponent as ɵa} from './src/app/modules/slideshow/slideshow.component';
export {SwipeService as ɵb} from './src/app/modules/slideshow/swipe.service';